// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MLfO","rootMobile":"styles_rootMobile__2fGlg"};